import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/shared/seo/global'

export const SEO_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
